import {SidebarUsedBy as UsedByComponent} from '@github-ui/code-view-sidebar/components/SidebarUsedBy'
import {isCombinedSidebarPayloadEnabled} from '@github-ui/code-view-sidebar/is-enabled'
import type {SidebarUsedByResponse} from '@github-ui/code-view-sidebar/types'
import {useCombinedSidebarPayload} from '@github-ui/code-view-sidebar/use-combined-sidebar-payload'
import {useSuspenseQuery} from '@github-ui/react-query'
import {verifiedFetchJSON} from '@github-ui/verified-fetch'

interface Props {
  ownerLogin: string
  repoName: string
}

export function SidebarUsedBy(props: Props) {
  return isCombinedSidebarPayloadEnabled() ? (
    <SidebarUsedByCombined {...props} />
  ) : (
    <SidebarUsedByIndividual {...props} />
  )
}

function SidebarUsedByCombined({ownerLogin, repoName}: Props) {
  const {usedBy} = useCombinedSidebarPayload(ownerLogin, repoName)
  if (!usedBy) return null
  return <UsedByComponent {...usedBy} />
}

function SidebarUsedByIndividual({ownerLogin, repoName}: Props) {
  const {data} = useSuspenseQuery({
    queryKey: ['code-view-sidebar', 'usedBy', {ownerLogin, repoName}],
    queryFn: async () => {
      const r = await verifiedFetchJSON(`/${ownerLogin}/${repoName}/_sidebar/used-by`)
      if (!r.ok) throw new Error(`Sidebar used-by fetch failed (${r.status})`)
      return (await r.json()) as SidebarUsedByResponse
    },
  })

  if (!data) return null
  return <UsedByComponent {...data} />
}
